export const toggleStyle = {
  backgroundColor: "transparent",
  color: "black",
  borderColor: "black",
};

export const menuStyle = {
  marginTop: "10px",
};
